import React from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'next-i18next';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import StyledBox from 'views/experience-module/MotorcycleTripView/components/MotorcycleTripHeaderSection/MotorcycleTripHeaderSection.styles';
import Typography500 from 'views/common/components/UI/Typography500';
import { ImgBox } from 'views/common/components';
import ScrollTo from 'lib/utils/ScrollTo';
import useMultiSizedImage from 'views/common/hooks/useMutiSizeImage';

const MotorcycleTripHeaderSection = (props) => {
  const { tripName, tripImg } = props;
  const { t } = useTranslation('fe_er_motorcycle_trip_page');
  const tripBGImage = useMultiSizedImage(tripImg);
  const handleShowMeButtonClick = (id) => ScrollTo(id);
  return (
    <StyledBox className="MTHSContainer">
      <Box className="MTHSDetails">
        <Typography500 component="p" variant="h2" className="MTHSTitle">
          {t('fe_er_motorcycle_trip_page:explore')}
        </Typography500>
        <Typography500 component="h1" variant="h2" className="MTHSSubTitle">
          {t('fe_er_motorcycle_trip_page:page_motorcycle_tours', {
            page_name: tripName,
          })}
        </Typography500>
        <Button
          className="MTHSButton"
          variant="contained"
          endIcon={<ArrowDropDownCircleIcon />}
          onClick={() => handleShowMeButtonClick('comparisonSection')}>
          {t('fe_er_motorcycle_trip_page:start_your_adventure')}
        </Button>
      </Box>
      <Box className="MTHSBackground MTHSBackgroundImg">
        <ImgBox
          image={{ src: tripBGImage, alt: tripName }}
          imgHeight="100%"
          priority
        />
      </Box>
      <Box className="MTHSBackground MTHSBackgroundOverlay" />
    </StyledBox>
  );
};

export { MotorcycleTripHeaderSection };
